import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import FullScreenLoader from "../components/FullScreenLoader";
import Login from "../pages/Login";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import Register from "../pages/Register";
import RegisterFree from "../pages/RegisterFree";
import RegisterClubAdmin from "../pages/RegisterClubAdmin";
import VerifyEmail from "../pages/VerifyEmail";
import InviteAccept from "../pages/InviteAccept";
import SetupAccount from "../pages/SetupAccount";
import AdminPlatforma from "../pages/dashboard/AdminPlatforma";
import AdminClub from "../pages/dashboard/AdminClub";
import TeamDetails from "../pages/dashboard/TeamDetails";
import Antrenor from "../pages/dashboard/Antrenor";
import Sportiv from "../pages/dashboard/Sportiv";
import UserManagement from "../pages/admin/UserManagement";
import UserDetails from "../pages/admin/UserDetails";
import Athletes from "../pages/admin/Athletes";
import Parents from "../pages/admin/Parents";
import Coaches from "../pages/admin/Coaches";
import ClubAdmins from "../pages/admin/ClubAdmins";
import PlatformAdmins from "../pages/admin/PlatformAdmins";
import ClubManagement from "../pages/admin/ClubManagement";
import QuizManagement from "../pages/admin/QuizManagement";
import QuizCategories from "../pages/admin/QuizCategories";
import QuizThemes from "../pages/admin/QuizThemes";
import AgeGroupsAdmin from "../pages/admin/AgeGroups";
import QuizSchedulesPage from "../pages/admin/QuizSchedules";
import ClubQuizzes from "../pages/admin/ClubQuizzes";
import PointsConfig from "../pages/admin/PointsConfig";
import AthletePlans from "../pages/admin/AthletePlans";
import AffiliateRewards from "../pages/admin/AffiliateRewards";
import AffiliateDashboard from "../pages/admin/AffiliateDashboard";
import ClubPlans from "../pages/admin/ClubPlans";
import AppAffiliate from "../pages/app/AppAffiliate";
import Settings from "../pages/admin/Settings";
import Revenue from "../pages/admin/Revenue";
import Notifications from "../pages/admin/Notifications";
import BadgesAdmin from "../pages/admin/BadgesAdmin";
import ReportsAnalytics from "../pages/admin/ReportsAnalytics";
import Support from "../pages/admin/Support";
import Billing from "../pages/admin/Billing";
import EmailLogs from "../pages/admin/EmailLogs";
import LifePackages from "../pages/admin/LifePackages";
import Marketing from "../pages/admin/Marketing";
import Analytics from "../pages/admin/Analytics";
import Contracts from "../pages/admin/Contracts";
import EmailTemplates from "../pages/admin/EmailTemplates";
import ClubDetails from "../pages/admin/ClubDetails";
import ClubMembers from "../pages/admin/ClubMembers";
import Products from "../pages/admin/Products";
import ClubAthletes from "../pages/admin/ClubAthletes";
import Events from "../pages/admin/Events";
import EventDetails from "../pages/admin/EventDetails";
import ClubSettings from "../pages/admin/ClubSettings";
import ClubOverview from "../pages/admin/ClubOverview";
import ClubTeams from "../pages/admin/ClubTeams";
import ClubCoaches from "../pages/admin/ClubCoaches";
import ClubStaff from "../pages/admin/ClubStaff";
import ClubSessions from "../pages/admin/ClubSessions";
import ClubInvoices from "../pages/admin/ClubInvoices";
import ClubReceivables from "../pages/admin/ClubReceivables";
import ClubReports from "../pages/admin/ClubReports";
import ClubAthleteDetails from "../pages/admin/ClubAthleteDetails";
import ClubLocations from "../pages/admin/ClubLocations";
import ClubCalendar from "../pages/admin/ClubCalendar";
import ClubLeaderboard from "../pages/admin/ClubLeaderboard";
import ClubSupport from "../pages/admin/ClubSupport";
import ClubPlanActivation from "../pages/admin/ClubPlanActivation";
import QuizTaking from "../pages/student/QuizTaking";
import DownloadAndroid from "../pages/DownloadAndroid";
import Privacy from "../pages/Privacy";
import Terms from "../pages/Terms";
import JoinTeam from "../pages/JoinTeam";
import OpenInApp from "../pages/OpenInApp";
import JoinTeamClaim from "../pages/JoinTeamClaim";
import ProtectedRoute from "../components/ProtectedRoute";
import { useAuth } from "../context/AuthContext";
import { trackPageview, bindAnalyticsLifecycle } from "../lib/webAnalytics";
import { TourProvider } from "../components/tour/TourProvider";
import { isNativeApp } from "../services/capacitor";

// Mobile App Pages - Athlete
import AppDashboard from "../pages/app/AppDashboard";
import AppSessions from "../pages/app/AppSessions";
import AppQuizzes from "../pages/app/AppQuizzes";
import CategoryQuizzes from "../pages/app/CategoryQuizzes";
import AppLeaderboard from "../pages/app/AppLeaderboard";
import AppPoints from "../pages/app/AppPoints";
import AppAttendance from "../pages/app/AppAttendance";
import AppSettings from "../pages/app/AppSettings";
import AppEvents from "../pages/app/AppEvents";
import AppPaymentHistory from "../pages/app/AppPaymentHistory";
import LivesShop from "../pages/app/LivesShop";
import AppPlans from "../pages/app/AppPlans";
import AppPointsInfo from "../pages/app/AppPointsInfo";
import AppProfile from "../pages/app/AppProfile";
import AppClubProfile from "../pages/app/AppClubProfile";
import AppTeamProfile from "../pages/app/AppTeamProfile";
import AppBadges from "../pages/app/AppBadges";

// Mobile App Pages - Coach
import AppCoachDashboard from "../pages/app/coach/AppCoachDashboard";
import AppCoachSessions from "../pages/app/coach/AppCoachSessions";
import AppCoachTeams from "../pages/app/coach/AppCoachTeams";
import AppCoachAthletes from "../pages/app/coach/AppCoachAthletes";
import AppCoachAttendance from "../pages/app/coach/AppCoachAttendance";
import AppCoachPoints from "../pages/app/coach/AppCoachPoints";
import AppCoachCalendar from "../pages/app/coach/AppCoachCalendar";
import AppCoachProfile from "../pages/app/coach/AppCoachProfile";
import AppCoachSettings from "../pages/app/coach/AppCoachSettings";
import AppCoachPayments from "../pages/app/coach/AppCoachPayments";
import AppCoachMetrics from "../pages/app/coach/AppCoachMetrics";
import AppCoachAthleteMetrics from "../pages/app/coach/AppCoachAthleteMetrics";
import AppCoachMetricsConfig from "../pages/app/coach/AppCoachMetricsConfig";
import AppCoachEvents from "../pages/app/coach/AppCoachEvents";
import AppCoachReports from "../pages/app/coach/AppCoachReports";

// Mobile App Pages - Parent
import AppParentDashboard from "../pages/app/parent/AppParentDashboard";
import AppParentEvents from "../pages/app/parent/AppParentEvents";
import AppParentPayments from "../pages/app/parent/AppParentPayments";
import AppParentAddChild from "../pages/app/parent/AppParentAddChild";
import AppParentPlans from "../pages/app/parent/AppParentPlans";

// Wrapper to show correct dashboard based on role
function AppDashboardWrapper() {
  const { activeRole } = useAuth();

  if (activeRole === "parent") {
    return <AppParentDashboard />;
  }
  // A coach landing on /app/dashboard would otherwise see the athlete home
  // (showing athlete-only widgets like "I'm in 2 teams as coach" pulled from
  // unrelated data). Bounce them to the proper coach home instead.
  if (activeRole === "coach") {
    return <Navigate to="/app/coach" replace />;
  }
  if (activeRole === "coordinator") {
    return <Navigate to="/dashboard/admin-club" replace />;
  }
  return <AppDashboard />;
}

// Bounce coaches off the athlete-only "/app/*" sub-pages so they don't see
// athlete widgets sourced from their (unrelated) data. Each athlete page
// keeps its element prop set to this wrapper, which renders the page only
// when the user is NOT a coach.
function CoachRedirect({ to, children }: { to: string; children: React.ReactNode }) {
  const { activeRole } = useAuth();
  if (activeRole === "coach") return <Navigate to={to} replace />;
  return <>{children}</>;
}

function DashboardRedirect() {
  const { activeRole, roles, loading } = useAuth();

  // Show loading while auth is being refreshed
  if (loading) return <FullScreenLoader />;

  // Get actual role codes the user has
  const roleCodes = roles.map((r) => r.code);

  // Check if user actually has platform_admin role (scope_type="platform")
  const hasPlatformAdmin = roles.some((r) => r.code === "platform_admin" && r.scope_type === "platform");
  // Check if user has club_admin role
  const hasClubAdmin = roleCodes.includes("club_admin");
  // Check if user has coach role
  const hasCoordinator = roleCodes.includes("coordinator");
  // Check if user has coach role
  const hasCoach = roleCodes.includes("coach");
  // Check if user has athlete role
  const hasAthlete = roleCodes.includes("athlete");
  // Check if user has parent role
  const hasParent = roleCodes.includes("parent");

  // Route based on activeRole FIRST (user's explicit choice)
  if (activeRole === "platform_admin" && hasPlatformAdmin) {
    return <Navigate to="/dashboard/admin-platforma" replace />;
  }
  if (activeRole === "club_admin" && hasClubAdmin) {
    return <Navigate to="/dashboard/admin-club" replace />;
  }
  // A coordinator runs a sport across several teams — desk work like the club
  // admin's, not the coach's team-by-team app view.
  if (activeRole === "coordinator" && hasCoordinator) {
    return <Navigate to="/dashboard/admin-club" replace />;
  }
  if (activeRole === "coach") {
    return <Navigate to="/app/coach" replace />;
  }
  if (activeRole === "parent") {
    return <Navigate to="/app/dashboard" replace />;
  }
  if (activeRole === "athlete") {
    return <Navigate to="/app" replace />;
  }

  // Fallback: use role priority (admins to dashboard, coaches/athletes/parents to mobile app)
  if (hasPlatformAdmin) return <Navigate to="/dashboard/admin-platforma" replace />;
  if (hasClubAdmin) return <Navigate to="/dashboard/admin-club" replace />;
  if (hasCoordinator) return <Navigate to="/dashboard/admin-club" replace />;
  if (hasCoach) return <Navigate to="/app/coach" replace />;
  if (hasParent) return <Navigate to="/app/dashboard" replace />;
  if (hasAthlete) return <Navigate to="/app" replace />;

  return <Navigate to="/dashboard" replace />; // fallback - try dashboard redirect again
}

// Reset window scroll on every pathname change. Without this, clicking a link
// from a long page (e.g. team detail → athlete profile) lands the user mid-
// page on the new route because React Router does not reset scroll itself.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

// Reports each route change to our own analytics. Sits next to ScrollToTop
// because both want exactly the same signal: the pathname changed.
function TrackPageviews() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  useEffect(() => {
    bindAnalyticsLifecycle();
  }, []);
  useEffect(() => {
    trackPageview(pathname, user?.id);
  }, [pathname, user?.id]);
  return null;
}

export default function AppRoutes() {
  return (
    <TourProvider>
    <ScrollToTop />
    <TrackPageviews />
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      {/* Opened from a shared link — public by design, so NOT wrapped in
          ProtectedRoute. The claim half is protected: it acts as the
          signed-in parent. */}
      <Route path="/join/:token" element={<JoinTeam />} />
      <Route path="/join/:token/claim" element={<ProtectedRoute><JoinTeamClaim /></ProtectedRoute>} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      {/* Înregistrare fără invitație — pe web ȘI în aplicație.
          The app used to send anybody who installed it from the store to a
          login screen with no way past it: the registration links were hidden
          natively and this route redirected back to /login. The flows existed,
          just not anywhere a person could reach them. Free plan only; the paid
          upgrade stays on the web. */}
      <Route path="/inregistrare" element={<RegisterFree />} />
      {/* The old self-serve page. Kept on the web for existing links; in the
          app it goes to the new flow rather than to a dead end. */}
      <Route path="/register" element={isNativeApp() ? <Navigate to="/inregistrare" replace /> : <Register />} />
      <Route path="/register-club" element={isNativeApp() ? <Navigate to="/login" replace /> : <RegisterClubAdmin />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/invite/:token" element={<InviteAccept />} />
      <Route path="/setup-account/:token" element={<SetupAccount />} />
      <Route path="/download-android" element={<DownloadAndroid />} />
      {/* Where email buttons point when the destination is the app. Public:
          it is opened before anyone has signed in on that device. */}
      <Route path="/open" element={<OpenInApp />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />

      <Route path="/dashboard" element={<ProtectedRoute><DashboardRedirect /></ProtectedRoute>} />
      <Route path="/dashboard/admin-platforma" element={<ProtectedRoute><AdminPlatforma /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club" element={<ProtectedRoute><ClubOverview /></ProtectedRoute>} />
      {/* Detalii club was merged into Setări; keep the old path working. */}
      <Route path="/dashboard/admin-club/details" element={<Navigate to="/dashboard/admin-club/settings" replace />} />
      <Route path="/dashboard/admin-club/teams" element={<ProtectedRoute><ClubTeams /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/teams/:teamId" element={<ProtectedRoute><TeamDetails /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/coaches" element={<ProtectedRoute><ClubCoaches /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/staff" element={<ProtectedRoute><ClubStaff /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/sessions" element={<ProtectedRoute><ClubSessions /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/invoices" element={<ProtectedRoute><ClubInvoices /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/receivables" element={<ProtectedRoute><ClubReceivables /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/reports" element={<ProtectedRoute><ClubReports /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/athletes/:athleteId" element={<ProtectedRoute><ClubAthleteDetails /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/locations" element={<ProtectedRoute><ClubLocations /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/calendar" element={<ProtectedRoute><ClubCalendar /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/leaderboard" element={<ProtectedRoute><ClubLeaderboard /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/support" element={<ProtectedRoute><ClubSupport /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/activare" element={<ProtectedRoute><ClubPlanActivation /></ProtectedRoute>} />
      <Route path="/dashboard/antrenor" element={<ProtectedRoute><Antrenor /></ProtectedRoute>} />
      <Route path="/dashboard/sportiv" element={<ProtectedRoute><Sportiv /></ProtectedRoute>} />

      {/* Admin Routes */}
      <Route path="/admin/users" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
      <Route path="/admin/users/:userId" element={<ProtectedRoute><UserDetails /></ProtectedRoute>} />
      <Route path="/admin/athletes" element={<ProtectedRoute><Athletes /></ProtectedRoute>} />
      <Route path="/admin/parents" element={<ProtectedRoute><Parents /></ProtectedRoute>} />
      <Route path="/admin/coaches" element={<ProtectedRoute><Coaches /></ProtectedRoute>} />
      <Route path="/admin/club-admins" element={<ProtectedRoute><ClubAdmins /></ProtectedRoute>} />
      <Route path="/admin/platform-admins" element={<ProtectedRoute><PlatformAdmins /></ProtectedRoute>} />
      <Route path="/admin/clubs" element={<ProtectedRoute><ClubManagement /></ProtectedRoute>} />
      <Route path="/admin/clubs/:clubId" element={<ProtectedRoute><ClubDetails /></ProtectedRoute>} />
      <Route path="/admin/clubs/:clubId/members" element={<ProtectedRoute><ClubMembers /></ProtectedRoute>} />
      <Route path="/admin/quizzes" element={<ProtectedRoute><QuizManagement /></ProtectedRoute>} />
      <Route path="/admin/quiz-categories" element={<ProtectedRoute><QuizCategories /></ProtectedRoute>} />
      <Route path="/admin/quiz-themes" element={<ProtectedRoute><QuizThemes /></ProtectedRoute>} />
      <Route path="/admin/quiz-schedules" element={<ProtectedRoute><QuizSchedulesPage /></ProtectedRoute>} />
      <Route path="/admin/age-groups" element={<ProtectedRoute><AgeGroupsAdmin /></ProtectedRoute>} />
      <Route path="/admin/points" element={<ProtectedRoute><PointsConfig /></ProtectedRoute>} />
      <Route path="/admin/athlete-plans" element={<ProtectedRoute><AthletePlans /></ProtectedRoute>} />
      <Route path="/admin/affiliate-rewards" element={<ProtectedRoute><AffiliateRewards /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/affiliate" element={<ProtectedRoute><AffiliateDashboard /></ProtectedRoute>} />
      <Route path="/admin/club-plans" element={<ProtectedRoute><ClubPlans /></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/admin/revenue" element={<ProtectedRoute><Revenue /></ProtectedRoute>} />
      <Route path="/admin/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
      <Route path="/admin/badges" element={<ProtectedRoute><BadgesAdmin /></ProtectedRoute>} />
      <Route path="/admin/reports" element={<ProtectedRoute><ReportsAnalytics /></ProtectedRoute>} />
      <Route path="/admin/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
      <Route path="/admin/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
      <Route path="/admin/email-templates" element={<ProtectedRoute><EmailTemplates /></ProtectedRoute>} />
      <Route path="/admin/email-logs" element={<ProtectedRoute><EmailLogs /></ProtectedRoute>} />
      <Route path="/admin/life-packages" element={<ProtectedRoute><LifePackages /></ProtectedRoute>} />
      <Route path="/admin/marketing" element={<ProtectedRoute><Marketing /></ProtectedRoute>} />
      <Route path="/admin/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
      <Route path="/admin/contracts" element={<ProtectedRoute><Contracts /></ProtectedRoute>} />

      {/* Club Admin Routes */}
      <Route path="/dashboard/admin-club/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/athletes" element={<ProtectedRoute><ClubAthletes /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/quizzes" element={<ProtectedRoute><ClubQuizzes /></ProtectedRoute>} />
      {/* Încasările antrenorilor sunt acum un tab in pagina De încasat. Ruta
          veche rămâne și redirecționează: e in istoricul browserelor, in
          bookmark-uri și in turul ghidat. */}
      <Route
        path="/dashboard/admin-club/coach-collections"
        element={<Navigate to="/dashboard/admin-club/receivables?tab=coach-cash" replace />}
      />
      <Route path="/dashboard/admin-club/events" element={<ProtectedRoute><Events /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/events/:eventId" element={<ProtectedRoute><EventDetails /></ProtectedRoute>} />
      <Route path="/dashboard/admin-club/settings" element={<ProtectedRoute><ClubSettings /></ProtectedRoute>} />

      {/* Student Routes */}
      <Route path="/quiz/:quizId" element={<ProtectedRoute><QuizTaking /></ProtectedRoute>} />

      {/* Mobile App Routes - Athletes */}
      <Route path="/app" element={<ProtectedRoute><Navigate to="/app/dashboard" replace /></ProtectedRoute>} />
      <Route path="/app/dashboard" element={<ProtectedRoute><AppDashboardWrapper /></ProtectedRoute>} />
      <Route path="/app/sessions" element={<ProtectedRoute><CoachRedirect to="/app/coach/sessions"><AppSessions /></CoachRedirect></ProtectedRoute>} />
      <Route path="/app/quizzes" element={<ProtectedRoute><AppQuizzes /></ProtectedRoute>} />
      <Route path="/app/quizzes/category/:name" element={<ProtectedRoute><CategoryQuizzes /></ProtectedRoute>} />
      <Route path="/app/quizzes/category/:name/theme/:themeId" element={<ProtectedRoute><CategoryQuizzes /></ProtectedRoute>} />
      <Route path="/app/leaderboard" element={<ProtectedRoute><AppLeaderboard /></ProtectedRoute>} />
      <Route path="/app/points" element={<ProtectedRoute><AppPoints /></ProtectedRoute>} />
      <Route path="/app/attendance" element={<ProtectedRoute><AppAttendance /></ProtectedRoute>} />
      <Route path="/app/settings" element={<ProtectedRoute><AppSettings /></ProtectedRoute>} />
      <Route path="/app/events" element={<ProtectedRoute><AppEvents /></ProtectedRoute>} />
      <Route path="/app/payments" element={<ProtectedRoute><AppPaymentHistory /></ProtectedRoute>} />
      <Route path="/app/lives" element={<ProtectedRoute><LivesShop /></ProtectedRoute>} />
      <Route path="/app/plans" element={<ProtectedRoute><AppPlans /></ProtectedRoute>} />
      <Route path="/app/points-info" element={<ProtectedRoute><AppPointsInfo /></ProtectedRoute>} />
      <Route path="/app/badges" element={<ProtectedRoute><AppBadges /></ProtectedRoute>} />
      <Route path="/app/profile" element={<ProtectedRoute><AppProfile /></ProtectedRoute>} />
      <Route path="/app/affiliate" element={<ProtectedRoute><AppAffiliate /></ProtectedRoute>} />
      <Route path="/app/profile/:userId" element={<ProtectedRoute><AppProfile /></ProtectedRoute>} />
      <Route path="/app/club/:clubId" element={<ProtectedRoute><AppClubProfile /></ProtectedRoute>} />
      <Route path="/app/team/:teamId" element={<ProtectedRoute><AppTeamProfile /></ProtectedRoute>} />

      {/* Mobile App Routes - Coach */}
      <Route path="/app/coach" element={<ProtectedRoute><AppCoachDashboard /></ProtectedRoute>} />
      <Route path="/app/coach/sessions" element={<ProtectedRoute><AppCoachSessions /></ProtectedRoute>} />
      <Route path="/app/coach/teams" element={<ProtectedRoute><AppCoachTeams /></ProtectedRoute>} />
      <Route path="/app/coach/athletes" element={<ProtectedRoute><AppCoachAthletes /></ProtectedRoute>} />
      <Route path="/app/coach/attendance" element={<ProtectedRoute><AppCoachAttendance /></ProtectedRoute>} />
      <Route path="/app/coach/points" element={<ProtectedRoute><AppCoachPoints /></ProtectedRoute>} />
      <Route path="/app/coach/calendar" element={<ProtectedRoute><AppCoachCalendar /></ProtectedRoute>} />
      <Route path="/app/coach/profile" element={<ProtectedRoute><AppCoachProfile /></ProtectedRoute>} />
      <Route path="/app/coach/settings" element={<ProtectedRoute><AppCoachSettings /></ProtectedRoute>} />
      <Route path="/app/coach/payments" element={<ProtectedRoute><AppCoachPayments /></ProtectedRoute>} />
      <Route path="/app/coach/metrics" element={<ProtectedRoute><AppCoachMetrics /></ProtectedRoute>} />
      <Route path="/app/coach/metrics/config" element={<ProtectedRoute><AppCoachMetricsConfig /></ProtectedRoute>} />
      <Route path="/app/coach/athletes/:athleteId/metrics" element={<ProtectedRoute><AppCoachAthleteMetrics /></ProtectedRoute>} />
      <Route path="/app/coach/events" element={<ProtectedRoute><AppCoachEvents /></ProtectedRoute>} />
      <Route path="/app/coach/reports" element={<ProtectedRoute><AppCoachReports /></ProtectedRoute>} />

      {/* Mobile App Routes - Parent */}
      <Route path="/app/parent" element={<ProtectedRoute><Navigate to="/app/dashboard" replace /></ProtectedRoute>} />
      <Route path="/app/parent/progress" element={<ProtectedRoute><AppParentDashboard /></ProtectedRoute>} />
      <Route path="/app/parent/sessions" element={<ProtectedRoute><AppParentDashboard /></ProtectedRoute>} />
      <Route path="/app/parent/attendance" element={<ProtectedRoute><AppParentDashboard /></ProtectedRoute>} />
      <Route path="/app/parent/points" element={<ProtectedRoute><AppParentDashboard /></ProtectedRoute>} />
      <Route path="/app/parent/metrics" element={<ProtectedRoute><AppParentDashboard /></ProtectedRoute>} />
      <Route path="/app/parent/events" element={<ProtectedRoute><AppParentEvents /></ProtectedRoute>} />
      <Route path="/app/parent/payments" element={<ProtectedRoute><AppParentPayments /></ProtectedRoute>} />
      <Route path="/app/parent/add-child" element={<ProtectedRoute><AppParentAddChild /></ProtectedRoute>} />
      <Route path="/app/parent/plans" element={<ProtectedRoute><AppParentPlans /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </TourProvider>
  );
}
